import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { prescriptionQKeys } from "@hooks/queries/prescription/queryKeys";


interface MutationProps {
  medicationId: string;
  prescriptionId: string;
  patientId: string;
}

export const useDeleteMedication = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ medicationId }: MutationProps) => {
      return api.delete(`medication/${medicationId}`);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: prescriptionQKeys.medication(variables.prescriptionId),
      });
      queryClient.invalidateQueries({
        queryKey: prescriptionQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Medication]", res);
    },
  });
};
